import client from "services/ngage/api-client";
import DataResource from "types/DataResource";
import {DataImport, DataImportData, DataImportSource, DataImportStatus} from "../../types/DataImport";
import deserializeDataImport from "./deserializers/data-import";
import {snakeKeys} from "../array";

// Types ----

type DataImportCriteria = {
  category?: string
  source?: DataImportSource
  status?: DataImportStatus
  sort?: string
  page?: number
  perPage?: number
}

// Requests ----

/**
 * Get all Data Imports that match the given criteria (paginated)
 */
async function filtered(criteria: DataImportCriteria = {}) {
  const params = Object.assign({page: 1, per_page: 25}, snakeKeys(criteria));
  const response = await client.get<DataResource<DataImport> | null>('/imports', {params})

  if (response.data) {
    response.data.data = response.data.data.map(deserializeDataImport)
  }

  return response.data
}

/**
 * Get a single Data Import with the given ID
 */
async function get(id: number) {
  return deserializeDataImport(
    (await client.get<DataImport>(`/imports/${id}`)).data
  )
}

/**
 * Store a new import
 *
 * @param data
 */
async function store(data: DataImportData) {
  return deserializeDataImport(
    (await client.post<DataImport>('/imports', data)).data
  )
}

// Export ----

const imports = {
  filtered,
  get,
  store,
}

export default imports;